import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import ui from './modules/ui'
import assets from './modules/assets'
import settings from './modules/settings'
import coins from './modules/coins'
import rate from './modules/rate'
import orders from './modules/orders'
import rates from './modules/rates'
import moderation from './modules/moderation'
import forecast from './modules/forecast'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth,
    rate,
    ui,
    assets,
    settings,
    coins,
    orders,
    rates,
    moderation,
    forecast
  },
  strict: debug,
})



// WEBPACK FOOTER //
// ./src/store/index.js